import { useRef, useState } from "react";

import { cn } from "~/lib/utils";
import { RegisterButton } from "../ui/register-button";

export const FunctionButton = ({
  index,
  className,
  onContext,
  onClick,
  color,
  label,
  disabled,
}: {
  index: number;
  className?: string;
  onContext?: () => void;
  onClick?: () => void;
  color?: string;
  label?: string;
  disabled?: boolean;
}) => {
  const [isLongPress, setIsLongPress] = useState(false);

  const longPressTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const startLongPress = () => {
    setIsLongPress(true);
    if (onContext) {
      onContext();
    }
  };

  const handleMouseDown = () => {
    setIsLongPress(false);
    longPressTimeoutRef.current = setTimeout(() => {
      startLongPress();
    }, 1000);
  };

  const handlePressEnd = () => {
    if (longPressTimeoutRef.current) {
      clearTimeout(longPressTimeoutRef.current); // Cancel long press if regular press
    }
  };

  const handleMouseUp = (e: React.PointerEvent<HTMLButtonElement>) => {
    handlePressEnd();

    if (!isLongPress) {
      // Handle regular press if it wasn't a long press
      if (e.button !== 0) return;
      if (onClick) {
        onClick();
      }
    }
  };

  return (
    <RegisterButton
      onPointerDown={handleMouseDown}
      onPointerUp={handleMouseUp}
      onPointerLeave={handlePressEnd}
      onContextMenu={(e) => {
        e.preventDefault();
        if (onContext) {
          onContext();
        }
      }}
      className={cn(
        "min-w-28 items-center justify-center rounded-none",
        className,
        disabled && "opacity-50",
      )}
      color={color ?? undefined}
    >
      <p className="text-white/20 text-xl absolute right-2 bottom-0">{index}</p>
      <p className="line-clamp-2 w-full truncate text-ellipsis whitespace-normal break-words">
        {label}
      </p>
    </RegisterButton>
  );
};
